module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '77xib1yd',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
